(function ($) {
  $(document).ready(function () {
    // initialize variables that will be populated later
    let comparisonChart, years;

    // declare utility functions
    const createRequest = util.createRequest,
      uniqueMonthsYears = util.uniqueMonthsYears,
      returnYearKeys = util.returnYearKeys;

    /**
     * This function is used to remove the chart if no data is returned
     */
    function removeChart(chart) {
      chart.removeChart();
      $('#year-comparison-chart').html('<h4 class="text-center">No Data Returned for Current Selections</h4>');
    }

    /**
     * This function is used to update the chart when the location or parameter dropdown is changed
     * @param  {array} data  [chart data]
     * @param  {objecy} chart [chart object to update]
     */
    function updateChart(data, chart, depths, depthValues) {
      $('#years-checkbox').empty();
      if (!data || data.length === 0) {
        removeChart(chart);
      } else {
        $('#year-comparison-chart h4').remove();
        let chartData = [...data];
        if (depths.length > 0 && depthValues.length > 0) {
          chartData = chartData.filter(d => depthValues.includes(parseFloat(d.depth_value)));
        }

        const series = uniqueMonthsYears('rdate', 'rvalue_converted', 'unit_name', chartData);
        years = returnYearKeys('rdate', chartData);
        yearChips.removeChips();
        yearChips.data = years.map(year => {
          return {
            value: year,
            display: year,
          };
        });
        yearChips.buildChips();

        if (years.length === 1) {
          yearChips.chips[years.length - 1].toggleState(true);
        } else {
          yearChips.chips[years.length - 2].toggleState(true);
          yearChips.chips[years.length - 1].toggleState(true);
        }
        comparisonChart.setKeys(yearChips.val());
        comparisonChart.setData(series);
        comparisonChart.buildChart();
      }
    }

    function toggleDropdownDisplay(dropdown, state) {
      if (state === 'show') {
        dropdown.container.parentElement.classList.remove('hidden');
      } else if (state === 'hide') {
        dropdown.container.parentElement.classList.add('hidden');
      }
    }

    function updateDepthsDropdown(depths) {
      depthsDropdown.uncheckAll();
      if (depths.length > 0) {
        depthsDropdown.data = depths.map(depth => {
          return {
            value: depth,
            display: `${depth} meters`,
          };
        });
        depthsDropdown.checked = [d3.min(depths)];
        depthsDropdown.buildDropdown().closeDropdown();

        const firstDepth = depthsDropdown.container.querySelector('.checkbox-dropdown-option .form-element-checkbox i');
        firstDepth.textContent = 'check_box';
        firstDepth.setAttribute('data-value', 'checked');

        toggleDropdownDisplay(depthsDropdown, 'show');
      } else {
        toggleDropdownDisplay(depthsDropdown, 'hide');
      }
    }

    // create locations list dropdown
    const locationsDropdown = new Dropdown({
      container: '#location-dropdown',
      elementExists: true,
      selectedValue: 79,
      onChange: () => {
        locationsDropdown.selectedValue = locationsDropdown.val();
        var promise = chartRequest();
        $.when(promise).done(data => {
          const response = JSON.parse(data);
          if (response) {
            const depths = [...new Set(response.filter(d => d.depth_value != null).map(d => +d.depth_value))].sort(
              (a, b) => a - b
            );
            updateDepthsDropdown(depths);
            updateChart(response, comparisonChart, depths, [d3.min(depths)]);
          } else {
            updateChart(response, comparisonChart, []);
          }
        });
      },
    });

    // create parameters list dropdown
    const parametersDropdown = new Dropdown({
      container: '#parameter-dropdown',
      elementExists: true,
      selectedValue: 29,
      onChange: function () {
        parametersDropdown.selectedValue = parametersDropdown.val();
        var promise = chartRequest();
        $.when(promise).done(data => {
          const response = JSON.parse(data);
          if (response) {
            const depths = [...new Set(response.filter(d => d.depth_value != null).map(d => +d.depth_value))].sort(
              (a, b) => a - b
            );
            updateDepthsDropdown(depths);
            updateChart(response, comparisonChart, depths, [d3.min(depths)]);
          } else {
            updateChart(response, comparisonChart, []);
          }
        });
      },
    });

    const depthsDropdown = new checkboxDropdown({
      parentContainer: '#filters-wrapper',
      elementExists: false,
      label: 'Select a depth',
      onChange: function (e) {
        if (
          e.target.classList.contains('checkbox-option-text') ||
          e.target.classList.contains('checkbox-option-icon')
        ) {
          var promise = chartRequest();
          $.when(promise).done(data => {
            const response = JSON.parse(data);
            if (response) {
              const depths = [...new Set(response.filter(d => d.depth_value != null).map(d => +d.depth_value))].sort(
                (a, b) => a - b
              );
              let depthValues = depthsDropdown.checked;
              if (depthValues.length > 0) {
                depthValues = depthValues.map(d => +d);
              }
              // updateDepthsDropdown(depths);
              updateChart(response, comparisonChart, depths, depthValues);
            } else {
              updateChart(response, comparisonChart, []);
            }
          });
        }
      },
    });

    // create the years chip bag
    const yearChips = new chipBag({
      container: '#years-checkbox',
      elementExists: true,
      onClick: () => {
        comparisonChart.setKeys(yearChips.activeChipsValues);
        comparisonChart.buildChart();
      },
    });

    // configure data request for locations dropdown list
    const locationsRequest = createRequest('viewer.download_dropdown_locs', '*', '', 1, false);
    const parametersRequest = createRequest('viewer.list_parameters_dropdown_simple', '*', '', 1, false);

    // create promises for dropdowns
    const locationsPromise = () => $.ajax(locationsRequest);
    const parametersPromise = () => $.ajax(parametersRequest);

    $.when(locationsPromise()).done(response => {
      const data = JSON.parse(response);
      if (data) {
        locationsDropdown.data = data;
        locationsDropdown.buildDropdown();
      }
    });

    $.when(parametersPromise()).done(response => {
      const data = JSON.parse(response);
      if (data) {
        parametersDropdown.data = data;
        parametersDropdown.buildDropdown();
      }
    });

    const chartOptions = {
      container: '#year-comparison-chart',
      width: $('#chart-div').width(),
      height: $('#chart-div').width() * 0.6,
    };

    function chartRequest() {
      return $.ajax({
        url: 'sites/all/scripts/correlation.php',
        data: {
          table: 'viewer.results_simple',
          fields: ['rdate', 'locationid', 'parameterid', 'rvalue_converted', 'unit_name', 'depth_value'],
          location: locationsDropdown.selectedValue,
          parameter1: parametersDropdown.selectedValue,
          parameter2: parametersDropdown.selectedValue,
          sort: 1,
        },
      });
    }

    const chartPromise = chartRequest();
    $.when(chartPromise).done(data => {
      const response = JSON.parse(data);
      if (response) {
        const depths = [...new Set(response.filter(d => d.depth_value != null).map(d => +d.depth_value))].sort(
          (a, b) => a - b
        );
        depthsDropdown.data = depths.map(depth => {
          return {
            value: depth,
            display: `${depth} meters`,
          };
        });
        depthsDropdown.checked = [d3.min(depths)];
        depthsDropdown.buildDropdown().closeDropdown();
        const firstDepth = depthsDropdown.container.querySelector('.checkbox-dropdown-option .form-element-checkbox i');
        firstDepth.textContent = 'check_box';
        firstDepth.setAttribute('data-value', 'checked');
        const filteredDepthData = response.filter(d => parseInt(d.depth_value) == 0);

        const series = uniqueMonthsYears('rdate', 'rvalue_converted', 'unit_name', filteredDepthData);
        years = returnYearKeys('rdate', filteredDepthData);

        comparisonChart = new columnChart(chartOptions, series, [years[years.length - 2], years[years.length - 1]]);
        yearChips.data = years.map(year => {
          return {
            value: year,
            display: year,
          };
        });
        yearChips.buildChips();
        yearChips.chips[years.length - 2].toggleState(true);
        yearChips.chips[years.length - 1].toggleState(true);
      } else {
        removeChart();
      }
    });
  });
})(jQuery);
